import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import ProductsListView from "../views/ProductsListView.vue";
import ProductsItemView from "../views/ProductsItemView.vue";
import ServicesListView from "../views/ServicesListView.vue";
import ServicesItemView from "../views/ServicesItemView.vue";
import Error404View from "../views/Error404View.vue";
import PolicyPrivacyView from "../views/PolicyPrivacyView.vue";
// import UnderConstructionView from "../views/UnderConstructionView.vue";

Vue.use(VueRouter);

const routes = [
  {
    name: "Início",
    path: "/",
    component: HomeView,
  },
  {
    name: "Quem Somos",
    path: "/quem-somos",
    component: AboutView,
  },
  {
    name: "Implementos",
    path: "/implementos",
    component: ProductsListView,
  },
  {
    name: "Implementos",
    path: "/implementos/:category",
    component: ProductsListView,
  },
  {
    name: "Implemento",
    path: "/implementos/:category/:item",
    component: ProductsItemView,
  },
  {
    name: "Serviços",
    path: "/servicos",
    component: ServicesListView,
  },
  {
    name: "Serviço",
    path: "/servicos/:item",
    component: ServicesItemView,
  },
  {
    name: "Política de Privacidade",
    path: "/politica-de-privacidade",
    component: PolicyPrivacyView,
  },
  {
    path: "/erro404",
    name: "Erro 404",
    component: Error404View,
  },
  {
    path: "*",
    name: "Erro 404",
    component: Error404View,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
